/* Hard block URL changes on collection pages to stop bouncing during auto load */
(() => {
  if (!/^\/collections\/[^/]+(\/|$)/.test(location.pathname)) return;

  try {
    // No ops, identical effect to your console patch
    history.pushState = new Proxy(history.pushState, {
      apply() { return; }
    });
    history.replaceState = new Proxy(history.replaceState, {
      apply() { return; }
    });
  } catch (e) {}
})();
